import packageJson from '../../../package.json';

const baseUrl = `${window.location.origin}`;

window.CKEDITOR_BASEPATH = `/static/V${packageJson.version}/ckeditor/`;
window.CKFINDER_BASEPATH = `/static/V${packageJson.version}/ckfinder/`;

export default {
  api: {
    baseUrl,
    authorization: '',
    enableBFF: true,
  },
  assetUrl: '{{SANDCASTLE_CDN}}',
  assetPath: `/static/V${packageJson.version}/assets/images/`,
  assetJsPath: `/static/V${packageJson.version}/assets/js/`,
  slideTemplatePath: '/content/media/slideTemplate/images/',
  learningModuleTemplatePath: `/static/V${packageJson.version}/assets/learning_module_template/`,
  baseName: '',
  ckFinderConnectorPath: `${baseUrl}/ckfc/ckfinder/connector`,
  getManifestURL: `${baseUrl}/get-manifest`,
  getNavigationURL: `${baseUrl}/bff/navigation`,
  getUserInfoURL: `${baseUrl}/bff/user`,
  getTokenURL: `${baseUrl}/oauth2-client/auth/check-token`,
  isAPMEnabled: true,
  launchDarklyClientSideId: process.env.REACT_APP_LAUNCHDARKLY_CLIENT_ID,
  OldCBTOKEN: 'd27cfd44d40d37576bbdfefa8ef30556',
  OldCBURL: 'https://elmocoursebuilder.com.au',
  serverUrl: 'https://p-pub-apm-server.elmotalent.com.au',
  serviceName: 'ELA - SPA',
  NextMenuUrl: 'https://hcm.cdn.elmotalent.com.au/menu-next/main.js',
};
